module.exports = __webpack_public_path__ + "static/img/zxj.f633e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/zxj.png
// module id = S28/
// module chunks = 1